export default "__VITE_ASSET__Bg7HyHIj__"